import { mountApp } from './app'

mountApp()
